import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { PositionIcon } from '@sorare/core/src/components/lineup/PositionIcon';
import { BaseballIcon } from '@sorare/core/src/components/lineup/PositionIcon/BaseballIcon';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { AppearanceRuleIcon_appearanceRule } from './__generated__/index.graphql.ts';

type Props = { appearanceRule: AppearanceRuleIcon_appearanceRule };

export const AppearanceRuleIcon = ({ appearanceRule }: Props) => {
  const { sport } = useSportContext();

  if (sport === Sport.BASEBALL) {
    return <BaseballIcon positions={appearanceRule.positions} size={4} />;
  }

  const position =
    appearanceRule.positions.length === 1 ? appearanceRule.positions[0] : null;

  return <PositionIcon position={position} />;
};

AppearanceRuleIcon.fragments = {
  appearanceRule: gql`
    fragment AppearanceRuleIcon_appearanceRule on AppearanceRule {
      id
      positions
    }
  ` as TypedDocumentNode<AppearanceRuleIcon_appearanceRule>,
};
